export default __webpack_public_path__ + "static/media/banner3.a5f3c921.png";